import { render, staticRenderFns } from "./Attach.vue?vue&type=template&id=c072d382"
import script from "./Attach.js?vue&type=script&lang=js&external"
export * from "./Attach.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports